<div class="modal in hs-composition-info-dialog" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    {{data.info.title}} <span>{{'COMPOSITIONS.dialogInfo.details' | translateHs
                        }}</span>
                </h4>
                <button type="button" (click)="close()" class="btn-close" data-dismiss="modal"
                    [attr.aria-label]="'COMMON.close' | translateHs ">
                </button>
            </div>
            <div class="modal-body" style="max-height: 600px; overflow-y: auto">
                <div class="row" style="text-align: justify; text-justify: inter-word;">
                    <div class="col-md-3"><b>{{'COMMON.abstract' | translateHs }}</b></div>
                    <div class="col-md-9">{{data.info.abstract}}</div>
                </div>
                <div *ngIf="data.info.keywords">
                    <div *ngFor="let keyword of data.info.keywords;let first = first;">
                        <div class="row" *ngIf="first">
                            <div class="col-md-3"><b>{{'COMMON.keywords' | translateHs }}</b></div>
                            <div class="col-md-9">{{keyword}}</div>
                        </div>
                        <div class="row" *ngIf="!first">
                            <div class="col-md-offset-3 col-md-9">{{keyword}}</div>
                        </div>
                    </div>
                    <br>
                </div>
                <div class="row" *ngIf="data.info.thumbnail">
                    <div class="col-md-3"><b>{{'COMMON.thumbnail' | translateHs }}</b></div>
                    <div class="col-md-9"><img
                            [src]="data.info.thumbnail.url ? data.info.thumbnail.url : data.info.thumbnail"></div>
                </div>
                <div class="row" *ngIf="data.info.url && data.info">
                    <div class="col-md-3"><b>{{'COMMON.url' | translateHs }}</b></div>
                    <div class="col-md-9">{{data.info.url}}</div>
                </div>
                <div class="row" *ngIf="data.info.srs">
                    <div class="col-md-3"><b>{{'ADDLAYERS.srs' | translateHs }}</b></div>
                    <div class="col-md-9">{{data.info.srs}}</div>
                </div>
                <div class="row" *ngIf="data.info.extent">
                    <div class="col-md-3"><b>{{'COMMON.extent' | translateHs }}</b></div>
                    <div class="col-md-9" style="word-break:break-all">{{data.info.extent}}</div>
                </div>
                <div *ngIf="data.info.layers">
                    <div *ngFor="let layer of data.info.layers;let first = first;">
                        <div class="row" *ngIf="first">
                            <div class="col-md-3"><b>{{'COMMON.layers' | translateHs }}</b></div>
                            <div class="col-md-9">{{layer.title}}</div>
                        </div>
                        <div class="row" *ngIf="!first">
                            <div class="offset-md-3 col-md-9">{{layer.title}}</div>
                        </div>
                    </div>
                    <br>
                </div>
                <!-- <div *ngIf="data.info.metadata">
                    <div class="row">
                         <div class="col"><b>{{'COMPOSITIONS.dialogInfo.metadataAboutMetadata' | translateHs }}</b></div>
                    </div>
                     <div *ngFor="let metadata of data.info.metadata | keyvalue">
                         <div class="row" *ngIf="metadata.value">
                            <div class="col-md-3"><b>{{HsCompositionsService.translateString('COMPOSITIONS.dialogInfo.metadata', metadata.key)}}</b></div>
                            <div class="col-md-9" style="overflow-wrap: break-word">{{metadata.value}}</div>
                         </div>
                     </div>
                </div> -->
                <div class="row" *ngIf="data.info.contactAddress || data.info.contactPersonPrimary">
                    <div class="col"><b>{{'COMMON.contactInformation' | translateHs }}</b></div>
                </div>
                <div *ngIf="data.info.contactAddress">
                    <div *ngFor="let data of data.info.contactAddress | keyvalue">
                        <div class="row" *ngIf="data.value">
                            <div class="col-md-4"><b>{{HsCompositionsService.translateString('SAVECOMPOSITION.form',
                                    data.key)}}</b></div>
                            <div class="col-md-8">{{data.value}}</div>
                        </div>
                    </div>
                </div>
                <div *ngIf="data.info.contactPersonPrimary">
                    <div *ngFor="let data of data.info.contactPersonPrimary | keyvalue">
                        <div class="row" *ngIf="data.value">
                            <div class="col-md-4" style="word-break:break-all">
                                <b>{{HsCompositionsService.translateString('SAVECOMPOSITION.form', data.key)}}</b>
                            </div>
                            <div class="col-md-8">{{data.value}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <ng-container *ngIf="data.info?.metadata?.record_url">
                    <a target="_blank" [href]="data.info.metadata.record_url" class="btn btn-primary"
                        (click)="close()">See
                        full metadata record <i class="icon icon-opennewwindow"></i></a>
                </ng-container>
                <button class="btn btn-secondary" (click)="close()" data-dismiss="modal">{{'COMMON.close' |
                    translateHs }}</button>
            </div>
        </div>
    </div>
</div>